import React from 'react';
import { Link, To } from 'react-router-dom';
import ArrowLeft2 from 'iconsax-react/dist/esm/ArrowLeft2';
interface CloseButtonProps {
	to: To;
	tailwindClasses?: string;
}

const BackButton = ({ to, tailwindClasses = '' }: CloseButtonProps) => {
	return (
		<Link to={to} >
			<div className={`rounded-xl border border-tablz-med-gray-5 bg-tablz-med-gray-2 flex justify-center items-center w-fit h-fi p-4 hover:bg-tablz-med-gray-6 ${tailwindClasses}`}>
				<ArrowLeft2 size={20} />
			</div>
		</Link>
	);
};

export default BackButton;